
<template>
  <div class="link-views white-bg">
    <span style="display:none;">{{isExpID}}</span>
    <div class="top">
      <router-link :to="{name:'item',params:{id:ExpID}}">
        <Button class="mr" type="primary">返回</Button>
      </router-link>
    </div>
    <div class="select-div">
      <div class="mr">
        <span>选择类型：</span>
        <i-select v-model="ResourceType" style="width:200px">
          <i-option value="0">所有类</i-option>
          <i-option value="s">视频类</i-option>
          <i-option value="w">文档类</i-option>
        </i-select>
      </div>
      <div>
        <Button
          type="primary"
          class="mr"
          icon="md-search"
          @click="sureSearch(ExpID,ResourceType)"
        >查询</Button>
        <Button type="primary" icon="md-refresh" @click="sureSearch(ExpID,'0')">重置</Button>
      </div>
    </div>
    <div class="table-div">
      <!-- 表格 -->
      <div class="list">
        <Row :gutter="16" v-if="resourceList.length>0">
          <i-col
            :xs="12"
            :sm="12"
            :md="12"
            :lg="8"
            :xl="6"
            :xxl="4"
            v-for="(item,index) in resourceList"
            :key="index"
            class="listItem"
          >
            <Card>
              <div style="text-align:center;">
                <div class="imgBox">
                  <div v-if="item.VideoUrl!=null" @click="changeActiveVideoUrl(item.VideoUrl)">
                    <video :src="port+item.VideoUrl"></video>
                  </div>
                  <a :href="port+item.DocUrl" target="_blank" download v-else>
                    <img border="0" src="../../../assets/imgs/text.png" :alt="item.FileName">
                  </a>
                </div>

                <div class="cardText text-center">
                  <Tooltip :content="item.FileName" placement="top">
                    <div class="text-overflow">{{item.FileName}}</div>
                  </Tooltip>
                </div>
              </div>
            </Card>
          </i-col>
        </Row>
        <div v-else class="nodata">暂无数据</div>
      </div>
    </div>
    <!-- 视频播放模态框 -->
    <Modal v-model="showModalVideoUrl" :mask-closable="false" title="视频" :closable="false">
      <video id="vide" v-if="activeVideoUrl" :src="port+activeVideoUrl" style="width:100%" controls></video>
      <div slot="footer">
        <Button type="text" @click="changeVideoUrl">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import * as homeConst from "../../../apiconfig/index.js";
import * as publicApi from "../../../api/public-api.js";
export default {
  name: "studyMaterials",
  data() {
    return {
      port: homeConst.baseUrl + "/", //baseurl
      ResourceType: "0", //文档类型
      ExpID: 0, //当前所属实验ID
      resourceList: [], //资料数组
      showModalVideoUrl: false,
      activeVideoUrl: ""
    };
  },
  mounted() {
    this.ExpID = this.$route.params.id;
  },
  watch: {
    ExpID(val) {
      this.sureSearch(this.ExpID, "0");
    }
  },
  computed: {
    isExpID() {
      this.ExpID = this.$route.params.id;
      return this.$route.params.id;
    }
  },
  methods: {
    // 获取所有文档
    async getpageArr() {
      this.resourceList = await publicApi.GetExpResourceList({
        ExpID: this.ExpID ? this.ExpID : 0,
        ResourceType: this.ResourceType ? this.ResourceType : 0
      });
      this.loading = false;
    },
    // 按条件搜索
    sureSearch(ExpID, ResourceType) {
      this.ResourceType = ResourceType;
      this.getpageArr();
    },
    // 显示视频播放模态框
    changeActiveVideoUrl(url) {
      this.activeVideoUrl = url;
      this.showModalVideoUrl = true;
    },
    // 关闭弹框
    changeVideoUrl() {
      var vide = document.getElementById("vide");
      vide.pause();
      this.showModalVideoUrl = false;
    }
  }
};
</script>

<style scoped>
</style>